// Reimplementação enxuta de src/routes/hooks (Minimal) sobre react-router v7.
// Só o que as libs copiadas usam: usePathname, useRouter, useParams,
// useSearchParams. Resolve `import ... from 'src/routes/hooks'`.
import { useMemo } from 'react';
import {
  useNavigate,
  useLocation,
  useParams as _useParams,
  useSearchParams as _useSearchParams,
} from 'react-router';

// ----------------------------------------------------------------------

export function usePathname() {
  const { pathname } = useLocation();
  return useMemo(() => pathname, [pathname]);
}

// ----------------------------------------------------------------------

export function useRouter() {
  const navigate = useNavigate();

  return useMemo(
    () => ({
      back: () => navigate(-1),
      forward: () => navigate(1),
      refresh: () => navigate(0),
      push: (href: string) => navigate(href),
      replace: (href: string) => navigate(href, { replace: true }),
    }),
    [navigate]
  );
}

// ----------------------------------------------------------------------

export function useParams() {
  const params = _useParams();
  return useMemo(() => params, [params]);
}

// ----------------------------------------------------------------------

export function useSearchParams() {
  const [searchParams] = _useSearchParams();
  return useMemo(() => searchParams, [searchParams]);
}
